import { render, staticRenderFns } from "./SalesFlyerView.vue?vue&type=template&id=c7c38b24"
import script from "./SalesFlyerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerView.vue?vue&type=style&index=0&id=c7c38b24&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports